import React from 'react';
import api from './api';
import CustomDataTable from './CustomDataTable'; // update path as needed
import AuthContext from '../context/AuthProvider';
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { canDo } from '../utils/canDo';
import "./Doctors.css";

class Services extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      services: [],
      suggestedServices: [],
      modRows: [],
      selectedRows: [],
      filters: {
        name: '',
        description: '',
        amount: '',
        qty: '',
        remarks: ''
      },
      branches: [],
      orgs: [],
      showModal: false,
      isEditMode: false,
      editServiceId: null,
      newService: {
        name: '',
        description: '',
        amount: '',
        qty: '',
        remarks: '',
        branch: 'selectB',
        org: 'selectOrg',
            igst: 0,
            cgst: 0,
            sgst: 0,
            ecess: 0,
      }
    };
  }

  componentDidMount() {
    this.fetchServices();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.patientCard !== this.props.patientCard ||
      prevProps.filterT !== this.props.filterT
    ) {
      this.fetchServices();
    }
  }

  fetchServices = () => {
    const { patientCard, filterT } = this.props;
    let endpoint = '';

    if (patientCard) {
      endpoint = `${patientCard}/type/${filterT}`;
    }

    api.get(`${process.env.REACT_APP_URL}/services/${endpoint}`)
      .then(response => {
        this.getBranches();
        if (patientCard) {
          const data = response.data || [];
          const preselected = data.filter(row => row.parentId && row.parentId !== '');
          this.setState({ suggestedServices: data, modRows: [], selectedRows: preselected });
        } else {
          this.setState({ services: response.data || [] });
        }
      })
      .catch(() => {
        alert('Error fetching services');
      });
  };

  getBranches = () => {
    api.get(`${process.env.REACT_APP_URL}/branches`)
      .then(response => {
        this.setState({ branches: response.data }, this.getOrgs);
      })
      .catch(error => {
        console.error('Error fetching branches:', error);
      });
  };

  getOrgs = () => {
    api.get(`${process.env.REACT_APP_URL}/orgs`)
      .then(response => {
        this.setState({ orgs: response.data });
      })
      .catch(error => {
        console.error('Error fetching orgs:', error);
      });
  };

  handleFilterChange = (key, value) => {
    this.setState(prevState => ({
      filters: { ...prevState.filters, [key]: value }
    }));
  };

 passesFilter = row => {
  const { filters } = this.state;

  return Object.entries(filters).every(([key, value]) => {
    const rowVal = row[key];
    return (String(rowVal || '')).toLowerCase().includes((value || '').toLowerCase());
  });
};


  toggleModal = (isEditMode = false, service = null) => {
    this.setState({
      showModal: !this.state.showModal,
      isEditMode,
    newService: {
      name: service?.name || '',
      description: service?.description || '',
      amount: service?.amount || 0,
      qty: service?.qty || 0,
         cgst: service?.cgst || 0,
      sgst: service?.sgst || 0,
      igst: service?.igst || 0,
      ecess: service?.ecess || 0,
      remarks: service?.remarks || '',
      branch: service?.branch || 'selectB',
      org: service?.org || 'selectOrg'
    },
      editServiceId: service?._id || null
    });
  };

  handleEditService = (serviceId) => {
    const { services } = this.state;
    const serviceToEdit = services.find(s => s._id === serviceId);
    if (serviceToEdit) {
      this.toggleModal(true, serviceToEdit);
    }
  };

  updateService = () => {
    const { newService, editServiceId } = this.state;

    if (!newService.name) {
      alert('Name is required.');
      return;
    }
    if (newService.branch === "selectB" || newService.org === "selectOrg") {
      alert("Please choose a valid branch / Org");
      return;
    }
 const requiredNumbers = ['amount', 'qty', 'cgst', 'sgst', 'igst', 'ecess'];
  const emptyFields = requiredNumbers.filter(key => {
    const val = newService[key];
    return val === '' || val === null || isNaN(val);
  });

  if (emptyFields.length > 0) {
    alert(`Please fill valid values for: ${emptyFields.join(', ')}`);
    return;
  }

    api.post(`${process.env.REACT_APP_URL}/services/update/${editServiceId}`, newService)
      .then(response => {
        alert("Service updated successfully");
        this.setState(prev => ({
          services: prev.services.map(s => s._id === editServiceId ? { ...newService, _id: editServiceId } : s),

          showModal: false,
          isEditMode: false,
          newService: {
            name: '',
            description: '',
            amount: '',
            qty: '',
            remarks: '',
            branch: 'selectB',
            org: 'selectOrg',
            igst: 0,
            cgst: 0,
            sgst: 0,
            ecess: 0,
          },
          editServiceId: null
        }));
      })
      .catch(() => {
        alert('Error updating service');
      });
  };

  prefilledSelectionCriteria = row => {
    return this.state.selectedRows.some(r => r._id === row._id);
  };

  handleCellChange = (key, id, e) => {
    const value = e.target.value;

    this.setState(prevState => {
      const dataCopy = [...prevState.suggestedServices];
      const idx = dataCopy.findIndex(r => r._id === id);
      if (idx < 0) return null;
      
      const updatedRow = { ...dataCopy[idx], [key]: value };
      dataCopy[idx] = updatedRow;

      const modRows = [...prevState.modRows];
      const modIdx = modRows.findIndex(r => r._id === updatedRow._id);
      if (modIdx >= 0) {
        modRows[modIdx] = updatedRow;
      } else {
        modRows.push(updatedRow);
      }

      const selectedRows = [...prevState.selectedRows];
      const selIdx = selectedRows.findIndex(r => r._id === updatedRow._id);
      if (selIdx >= 0) {
        selectedRows[selIdx] = updatedRow;
      } else {
        selectedRows.push(updatedRow);
      }

      return {
        suggestedServices: dataCopy,
        modRows,
        selectedRows
      };
    }, () => {
      if (this.props.onDataChange) {
        const combinedMap = new Map();
        this.state.modRows.forEach(r => combinedMap.set(r._id, r));
        this.state.selectedRows.forEach(r => combinedMap.set(r._id, r));
        this.props.onDataChange(Array.from(combinedMap.values()));
      }
    });
  };

  handleSeqChange = e => {
    const selectedRows = e.selectedRows;
    this.setState({ selectedRows }, () => {
      const { selectedRows, modRows } = this.state;
      const combinedMap = new Map();
      selectedRows.forEach(r => combinedMap.set(r._id, r));
      modRows.forEach(r => combinedMap.set(r._id, r));
      const combinedRows = Array.from(combinedMap.values());

      if (this.props.onDataChange) {
        this.props.onDataChange(combinedRows);
      }
    });
  };

  handleNewServiceChange = (key, value) => {
    this.setState(prev => ({
      newService: { ...prev.newService, [key]: value }
    }));
  };

  addNewService = () => {
    const { newService } = this.state;
    if (!newService.name) {
      alert('Name is required.');
      return;
    }
    if (newService.branch === "selectB" || newService.org === "selectOrg") {
      alert("Please choose a valid branch / Org");
      return;
    }
    
    api.post(`${process.env.REACT_APP_URL}/services/add`, newService)
      .then(response => {
        alert("Service added successfully");
        const newEntry = {
          ...newService,
          _id: 'temp_' + Date.now(),
          parentId: ''
        };
        this.setState(prev => ({
          services: [...prev.services, newEntry],
          showModal: false,
          newService: {
            name: '',
            description: '',
            amount: '',
            qty: '',
            remarks: '',
            branch: 'selectB',
            org: 'selectOrg',
                igst: 0,
            cgst: 0,
            sgst: 0,
            ecess: 0,
          }
        }));
      })
      .catch(error => alert('Error adding service'));
  };
handleDeleteService = (id) => {
  if (window.confirm("Are you sure you want to delete this service?")) {
    api.delete(`${process.env.REACT_APP_URL}/services/delete/${id}`)
      .then(() => {
        this.setState(prev => ({
          services: prev.services.filter(s => s._id !== id)
        }));
        alert("Service deleted successfully");
      })
      .catch(() => {
        alert("Error deleting service");
      });
  }
};

  render() {
    const { patientCard } = this.props;
    const auth = this.context.auth;
    console.log("auth context = ", this.context)
    const {
      suggestedServices,
      services,
      filters,
      showModal,
      newService,
      branches,
      orgs,
      isEditMode
    } = this.state;

    const rowsToShow = (suggestedServices || [])
      .filter(this.passesFilter)
      .sort((a, b) => {
        return (a.parentId && a.parentId !== '' ? 0 : 1) - (b.parentId && b.parentId !== '' ? 0 : 1);
      });


    var columns = [
      {
        name: "Name",
        selector: function (row) {
          return row && row.name ? row.name : '';
        },
        sortable: true,
        width: "120px",
        wrap: true, 
        filterable: true
      },
      {
        name: "Description",
        selector: function (row) {
          return row && row.description ? row.description : '';
        },
        sortable: true,
        width: "120px",
        filterable: false ,
        wrap: true, 
      },
      {
        name: "Amount",
        selector: function (row) {
          return row && row.amount != null ? row.amount : '';
        },
        sortable: true,
        width: "5rem", 
        
      },
      
      {
        name: "Qty",
        selector: function (row) {
          return row && row.qty != null ? row.qty : '';
        },
        
        sortable: true
      },
        
      {
        name: "Sgst",
        selector: function (row) {
          return row && row.sgst != null ? row.sgst : '';
        },
        sortable: true
      },
      {
        name: "Cgst",
        selector: function (row) {
          return row && row.cgst != null ? row.cgst : '';
        },
        sortable: true
      },
      {
        name: "Igst",
        selector: function (row) {
          return row && row.igst != null ? row.igst : '';
        },
        sortable: true
      },
      {
        name: "ECess",
        selector: function (row) {
          return row && row.ecess != null ? row.ecess : '';
        },
        sortable: true
      },
      {
        name: "Comments",
        selector: function (row) {
          return row && row.comments ? row.comments : '';
        },
        sortable: true,
        wrap: true,
         filterable: false ,
        width: "30px"
      },
      {
        name: "Branch",
        selector: function (row) {
          return row && row.branch ? row.branch : '';
        },
        sortable: true, 
      
      },
      {
        name: "Org",
        selector: function (row) {
          return row && row.org ? row.org : '';
        },
        sortable: true, 
        
      },
      {
        name: "Actions",
        sortable: false,
        filterable: false ,
        cell: row => (
          <>
           <div style={{ display: 'flex', gap: '30px', alignItems: 'center' }}>
            <FaEdit
              size={18} // Adjust size as needed
              style={{ cursor: 'pointer', color: 'green'}}
              onClick={() => {
               // console.log('Clicked edit on row:', row);
                this.handleEditService(row && row._id);
              }}
            />
            {canDo(auth, 'services.delete') && (
              <FaTrash
                size={18} // Same size for consistency
                style={{ cursor: 'pointer',color: 'red' }}
                onClick={() => {
                 // console.log("Deleting service with ID:", row && row._id);
                  this.handleDeleteService(row && row._id);
                }}
              />
            )}
          </div>
          </>
        )
      }
    ];

    var serviceColumns = [
      {
        name: "Name",
          filterKey: "name",  // Use this
        selector: function (row) {
          return row && row.name ? row.name : '';
        },
        sortable: true,
        wrap: true, 
        minWidth: '120px'
    
      },
      {
        name: "Description",
          filterKey: "description",  // Use this
        selector: function (row) {
          return row && row.description ? row.description : '';
        },
        sortable: true,
        wrap: true,
        filterable: false,
        minWidth: '220px'
      },
      {
        name: "Amount",
          filterKey: "amount",  // Use this
        selector: function (row) {
          return row && row.amount != null ? row.amount : '';
        },
        sortable: true,
        wrap: true
      },
      {
        name: "Qty",
          filterKey: "qty",  // Use this
        selector: row => (row && row.qty != null ? row.qty : ''),
        sortable: true,
        wrap: true,
        maxWidth: '20px',
        cell: (row, index) => (
          <input
            type="text"
            value={row && row.qty != null ? row.qty : ''}
          onChange={e => this.handleCellChange("qty", row._id, e)}

          />
        )
      },
      {
        name: "",
        wrap: true,
        filterable: false ,
        maxWidth: '20px',
        selector: function (row) {
          if (!row) return "";
          if (row.removedByPatient === true) return "❌";
          if (row.modifiedQtyByPatient != null && row.modifiedQtyByPatient !== 0) return "✔";
          return "";
        }
      },
      {
        name: "Modified Qty By Patient ?",
          filterKey: "modifiedQtyByPatient",  // Use this
        selector: function (row) {
          return row && row.modifiedQtyByPatient != null ? row.modifiedQtyByPatient : '';
        },
        filterable: false ,
        maxWidth: '20px',
        wrap: true
      },
      {
        name: "Patient Remarks",
        filterKey: "remarks",  // Use this
        selector: function (row) {
          return row && row.remarks ? row.remarks : '';
        },
        filterable: false ,
        wrap: true
      }
    ];

    return (
      <div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:12,marginBottom:20,marginTop:8}}>
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <div style={{width:42,height:42,borderRadius:12,background:'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:20,fontWeight:800,flexShrink:0}}>🛠️</div>
            <div style={{fontSize:20,fontWeight:800,color:'#1e293b',letterSpacing:-0.5}}>Services</div>
          </div>
          {!patientCard && (
            <button onClick={() => this.toggleModal(false, null)}
              style={{display:'flex',alignItems:'center',gap:8,padding:'10px 20px',borderRadius:10,border:'none',background:'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 14px rgba(37,99,235,0.3)',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
              + Add New Service
            </button>
          )}
        </div>

        <table className="doctors-table" style={{ marginTop: '10px' }}>
         <thead>
  
</thead>

        </table>

        {
          patientCard ? (

            <CustomDataTable
              columns={serviceColumns}
              data={suggestedServices}
              selectableRows={true}
              selectableRowSelected={this.prefilledSelectionCriteria}
              onSelectedRowsChange={this.handleSeqChange}
              paginationPerPage={100}
            />
          ) : (
            <CustomDataTable
              data={services.filter(s => s.org !== "ReRoot")}
              columns={columns}
              //data={services}
              paginationPerPage={100}
            />
          )
        }

    {showModal && (
  <div style={{position:'fixed',inset:0,zIndex:9000,background:'rgba(15,23,42,0.6)',backdropFilter:'blur(8px)',WebkitBackdropFilter:'blur(8px)',display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
    <div style={{background:'#fff',borderRadius:20,boxShadow:'0 25px 80px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.1)',width:'100%',maxWidth:680,maxHeight:'92vh',display:'flex',flexDirection:'column',overflow:'hidden'}}>
      {/* Header */}
      <div style={{background:'linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #3b82f6 100%)',padding:'0 24px',height:56,display:'flex',alignItems:'center',gap:12,flexShrink:0}}>
        <div style={{width:32,height:32,borderRadius:10,background:'rgba(255,255,255,0.15)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>🛠️</div>
        <div style={{flex:1}}>
          <div style={{fontSize:15,fontWeight:700,color:'#fff',letterSpacing:-0.3}}>{isEditMode ? 'Edit Service' : 'Add New Service'}</div>
          <div style={{fontSize:11,color:'rgba(255,255,255,0.6)',fontWeight:500}}>{isEditMode ? 'Update service details' : 'Configure a new service offering'}</div>
        </div>
        <button onClick={() => this.toggleModal(false)} style={{width:30,height:30,borderRadius:8,background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'#fff',fontSize:16,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
        >×</button>
      </div>
      {/* Body */}
      <div style={{overflowY:'auto',flex:1,padding:'24px 28px',background:'#fafbfc'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'18px 24px'}}>
          <div>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Service Name</label>
            <input value={newService.name} onChange={e => this.handleNewServiceChange('name', e.target.value)}
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
          </div>
          <div>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Amount</label>
            <input value={newService.amount} onChange={e => this.handleNewServiceChange('amount', e.target.value)} type="number"
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
          </div>
          <div style={{gridColumn:'1 / -1'}}>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Description</label>
            <textarea value={newService.description} onChange={e => this.handleNewServiceChange('description', e.target.value)}
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif",height:60,resize:'vertical'}} />
          </div>
          <div>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Quantity</label>
            <input value={newService.qty} onChange={e => this.handleNewServiceChange('qty', e.target.value)} type="number"
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
          </div>
          <div>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Branch</label>
            <select value={newService.branch} onChange={e => this.handleNewServiceChange('branch', e.target.value)}
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
              <option value="selectB">Select Branch</option>
              {branches.filter(b => b.isActive !== false && b.status !== 'inactive').map(branch => (
                <option key={branch.name} value={branch.name}>{branch.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Org</label>
            <select value={newService.org} onChange={e => this.handleNewServiceChange('org', e.target.value)}
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>
              <option value="selectOrg">Select Org</option>
              {orgs.map(org => (
                <option key={org.name} value={org.name}>{org.name}</option>
              ))}
            </select>
          </div>
          {/* Tax fields section */}
          <div style={{gridColumn:'1 / -1',marginTop:4}}>
            <div style={{fontSize:11,fontWeight:700,color:'#94a3b8',textTransform:'uppercase',letterSpacing:'0.06em',marginBottom:12,fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Tax Details</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:'14px'}}>
              <div>
                <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>CGST</label>
                <input value={newService.cgst} onChange={e => this.handleNewServiceChange('cgst', e.target.value)} type="number"
                  style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
              </div>
              <div>
                <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>SGST</label>
                <input value={newService.sgst} onChange={e => this.handleNewServiceChange('sgst', e.target.value)} type="number"
                  style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
              </div>
              <div>
                <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>IGST</label>
                <input value={newService.igst} onChange={e => this.handleNewServiceChange('igst', e.target.value)} type="number"
                  style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
              </div>
              <div>
                <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Ecess</label>
                <input value={newService.ecess} onChange={e => this.handleNewServiceChange('ecess', e.target.value)} type="number"
                  style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}} />
              </div>
            </div>
          </div>
          <div style={{gridColumn:'1 / -1'}}>
            <label style={{display:'block',marginBottom:6,fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.06em',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Remarks</label>
            <textarea value={newService.remarks} onChange={e => this.handleNewServiceChange('remarks', e.target.value)}
              style={{width:'100%',padding:'11px 14px',borderRadius:10,border:'1.5px solid #e2e8f0',fontSize:14,color:'#0f172a',background:'#fff',boxSizing:'border-box',outline:'none',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif",height:60,resize:'vertical'}} />
          </div>
        </div>
        {/* Footer */}
        <div style={{display:'flex',gap:12,marginTop:28,justifyContent:'flex-end'}}>
          <button onClick={() => this.toggleModal(false)}
            style={{padding:'11px 24px',borderRadius:10,border:'1.5px solid #e2e8f0',background:'#fff',color:'#64748b',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>Cancel</button>
          <button onClick={isEditMode ? this.updateService : this.addNewService}
            style={{padding:'11px 28px',borderRadius:10,border:'none',background:'#2563eb',color:'#fff',fontSize:13,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 14px rgba(37,99,235,0.3)',fontFamily:"'Inter','SF Pro Display',system-ui,sans-serif"}}>{isEditMode ? 'Update' : 'Add'} Service</button>
        </div>
      </div>
    </div>
  </div>
)}

      </div>
    );
  }
}

export default Services;
